// import '../Scss/Frontend/Elements/SearchBox.scss';
// import '/var/www/html/public/typo3conf/ext/solr/Resources/Public/StyleSheets/Frontend/suggest.css';
import $ from 'jquery';
// import '/var/www/html/public/typo3conf/ext/solr/Resources/Public/JavaScript/JQuery/jquery.autocomplete.min.js';
// import '/var/www/html/public/typo3conf/ext/solr/Resources/Public/JavaScript/suggest_controller.js';


let $searchBox = $('.SearchBox'),
	$input = $searchBox.find('.form-control');

$searchBox.on('click', (e) => {
	if ($input.val() === '' || !$searchBox.hasClass('active')) {
		e.preventDefault();
	}
	$input.trigger('focus');
});

$input.on(
	'focus focusout',
	e => {
		$searchBox.toggleClass('active', e.type === 'focus');
		$('body').toggleClass('searchBoxOpen', e.type === 'focus');
	}
);